import { IArchivingProceduralDocumentationExportEntityEvents } from '@core/interfaces/entity.interface';


// ENUMS #############################################################
// API enums *********************************************************
export enum ArchivingProceduralDocumentationExportStatusEnum {
	CANCELLED = 'CANCELLED',
	COLLECTING = 'COLLECTING',
	DELETED = 'DELETED',
	ERROR = 'ERROR',
	GENERATING = 'GENERATING',
	PENDING = 'PENDING',
	READY = 'READY'
}

// UI enums *********************************************************


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class ArchivingProceduralDocumentationExportTMO {
	public businessPremisesId?: string = undefined;

	public created?: Date = undefined;

	public createdBy?: string = undefined;

	public expiration?: Date = undefined;

	public extendable?: boolean = undefined;

	public filesize?: number = undefined;

	public id?: string = undefined;

	public lastModified?: Date = undefined;

	public lastModifiedBy?: string = undefined;

	public result?: ArchivingProceduralDocumentationExportResult = undefined;

	public status?: ArchivingProceduralDocumentationExportStatusEnum = undefined;
}

export class ArchivingProceduralDocumentationExportResultTMO {
	public url?: string = undefined;
}

export class CreateArchivingProceduralDocumentationExportBodyTMO {
	public proceduralDocumentationIds?: string[] = undefined;
	public validity?: CreateArchivingProceduralDocumentationExportValidityTMO = undefined;
}

export class CreateArchivingProceduralDocumentationExportValidityTMO {
	public validFrom?: string = undefined;
	public validTo?: string = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ArchivingProceduralDocumentationExport extends ArchivingProceduralDocumentationExportTMO {
	public ui?: IArchivingProceduralDocumentationExportEntityEvents = {
		daysLeftUntilExpire: undefined
	};
}

export class ArchivingProceduralDocumentationExportResult extends ArchivingProceduralDocumentationExportResultTMO {}

export class CreateArchivingProceduralDocumentationExportBody extends CreateArchivingProceduralDocumentationExportBodyTMO {}

export class CreateArchivingProceduralDocumentationExportValidity extends CreateArchivingProceduralDocumentationExportValidityTMO {}

export class ArchivingProceduralDocumentationExportDateRequest {
	public validFrom?: Date = undefined;
	public validTo?: Date = undefined;
}
